var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"text-center",staticStyle:{"height":"30px !important","width":"30px !important"},attrs:{"src":_vm.iconURL,"alt":"","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }